import { atom } from "recoil";
export const colorDbState = atom({
  key: "colorTable",
  default: []
})
export const ownerState = atom({
  key: "ownerState",
  default: null
})
export const selTableIDState = atom({
  key: "selectedColorTable",
  default: 0
})

export const selColorRowsState = atom({
  key: "selectedColorRows",
  default: []
})
export const scrollToViewIndRow = atom({
  key: "",
  default: null
})